@defer (when value()) {
  <app-permissions-form
    [edit]="true"
    [(value)]="value"
    [id]="id"
    [access]="access()"
  ></app-permissions-form>
}
